import { render, staticRenderFns } from "./eventModal.vue?vue&type=template&id=b166df98&scoped=true&"
import script from "./eventModal.vue?vue&type=script&lang=js&"
export * from "./eventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b166df98",
  null
  
)

export default component.exports